// KnowledgeBase Quasar-style Tables plugin
// Post-processes Markdown tables into Quasar-styled markup (no Vue mount required).
// This keeps Preview lightweight and consistent with Quasar visuals.

import { registerMarkdownPostProcessor } from '../../services/PluginAPI.js'
import './styles/tables.css'

function enhanceTable(table) {
  if (!table || table.__kb_qmt_applied) return
  table.__kb_qmt_applied = true

  // Wrap table in a scroll container
  const wrapper = document.createElement('div')
  wrapper.className = 'kb-qmt'

  // Add styling classes on table
  table.classList.add('kb-qmt-table')

  // Move table into wrapper
  const parent = table.parentElement
  if (parent) {
    parent.replaceChild(wrapper, table)
    wrapper.appendChild(table)
  }

  // If table has no <thead> but first row looks like a header, convert it
  try {
    const hasThead = !!table.querySelector('thead')
    if (!hasThead) {
      const firstRow = table.querySelector('tr')
      if (firstRow && firstRow.parentElement && firstRow.parentElement.tagName === 'TBODY') {
        const cells = Array.from(firstRow.children)
        const mostlyText =
          cells.filter((c) => !!(c.textContent || '').trim()).length >=
          Math.max(1, cells.length - 1)
        if (mostlyText) {
          const thead = document.createElement('thead')
          const tr = document.createElement('tr')
          cells.forEach((td) => {
            const th = document.createElement('th')
            th.innerHTML = td.innerHTML
            tr.appendChild(th)
          })
          thead.appendChild(tr)
          const tbody = firstRow.parentElement
          tbody.removeChild(firstRow)
          table.insertBefore(thead, tbody)
        }
      }
    }
  } catch {}
}

export function registerQuasarTablesPlugin() {
  registerMarkdownPostProcessor(
    (root) => {
      const tables = Array.from(root.querySelectorAll('table'))
      for (const t of tables) {
        try {
          enhanceTable(t)
        } catch {}
      }
    },
    { sortOrder: 40 }
  )
}

export default { registerQuasarTablesPlugin }
